import {Component, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {
  Contact,
  CustomerService,
  InsuranceCategory,
  Ref,
  SearchResult,
  SimplePaginationUtils,
  Ticket,
  TicketContact,
  TicketContactSearch,
  TicketContactService,
  TicketContactType,
  TicketInsuranceMandateRequest,
  TicketSearch,
  TicketService,
  ValidationResult,
} from '@lifeislife/lifeislife-domain';
import {CustomerContextService} from '../../service/customer-context-service';
import {map, publishReplay, refCount, switchMap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

@Component({
  selector: 'cf-insurance-mandate-request-item',
  templateUrl: './insurance-mandate-request-item.component.html',
  styleUrls: ['./insurance-mandate-request-item.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: InsuranceMandateRequestItemComponent,
    multi: true,
  }],
})
export class InsuranceMandateRequestItemComponent implements OnInit, ControlValueAccessor {


  value: TicketInsuranceMandateRequest;

  @Input()
  disabled: boolean;
  @Input()
  validationResults: ValidationResult<TicketInsuranceMandateRequest>;
  @Input()
  id: string = '';

  loggedCustomerName$: Observable<string>;

  contactSubscriberIsLoggedContact = true;

  private onChange: Function;
  private onTouched: Function;

  constructor(
    private customerContext: CustomerContextService,
    private customerService: CustomerService,
    private ticketService: TicketService,
  ) {
  }

  ngOnInit(): void {
    this.loggedCustomerName$ = this.customerContext.activeCustomerContact$.pipe(
      switchMap(cc => cc == null ? of(null) : this.customerService.getCustomer$(cc.customerRef)),
      map(c => c == null ? null : c.name),
      publishReplay(1), refCount(),
    );
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  fireUpdate(update: Partial<TicketInsuranceMandateRequest>) {
    const updatedValue = Object.assign({}, this.value, update);
    this.value = updatedValue;
    this.fireChanges();
  }

  fireCustomerUpdate(customerSubscriber: boolean) {
    if (this.value == null) {
      return;
    }
    if (customerSubscriber) {
      this.fireUpdate({
        customerSubscriber: true,
      });
    } else {
      this.fireUpdate({
        customerSubscriber: false,
      });
    }
  }

  fireChanges() {
    if (this.onTouched) {
      this.onTouched();
    }
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  onCategoryChanged(ref: Ref<InsuranceCategory> | string | null) {
    if (ref == null) {
      this.fireUpdate({insuranceCategoryRef: null, providerCategoryName: null});
    } else if (typeof ref === 'string') {
      this.fireUpdate({insuranceCategoryRef: null, providerCategoryName: ref});
    } else {
      this.fireUpdate({insuranceCategoryRef: ref, providerCategoryName: null});
    }
  }
}
